export default __webpack_public_path__ + "static/media/noa-24.694c8e15.jpg";